export const isProdEnv = process.env.REACT_APP_ENV === 'production';
